import { isLaunchedInFrame } from './iframe-context.helper';

export function getFrontendTheme() {
  if (!isLaunchedInFrame()) {
    return null;
  }
  return useRoute()?.query?.origin === 'rixos' ? 'rixos' : null;
}
